import axios from "axios";
import Vue from "vue";

const api = axios.create({
    baseURL: process.env.NODE_ENV === "production"
        ? "https://papi.sucai.online/jike"
        : "https://papi.sucai.online/jike",
    timeout: 30000,
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`.length > 20 ? `Bearer ${window.localStorage.getItem("token")}` : ''
    }
});

//本站API,用以设置api,key
Vue.prototype.$api = api;

export default api;
